import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TbCar } from "react-icons/tb";

import CommonPopup from "@/components/CommonPopup";
import { useUsersShowVehicleUpdateDialog, useUsersTableActions } from "@/stores/use-users-table";

import UpdateVehicleDialog from "./UpdateVehicleDialog";

function UserUpdateVehicleComp() {
    const { t } = useTranslation();
    const uservehicleUpdateInfo = useUsersShowVehicleUpdateDialog();
    const { updateShowVehicleUpdateDialog } = useUsersTableActions();
    const onClose = () => {
        updateShowVehicleUpdateDialog();
    };
    return (
        <CommonPopup
            title={t("buttons.updateUserVehicle")}
            icon={TbCar}
            open={!!uservehicleUpdateInfo}
            size="sm"
            onClose={onClose}
        >
            <>
                <Alert severity="info">
                    Şoföre atamak istediğiniz aracı seçiniz.Seçili araç başka bir şoför tarafından kullanılıyor ise
                    ilgili kişiden araç silinerek bu kullanıcıya atanacaktır.
                </Alert>
                <UpdateVehicleDialog />
            </>
        </CommonPopup>
    );
}

export default UserUpdateVehicleComp;
